import "../../css/Forms.css"
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Form, Input, Select, Checkbox, Flex, Button } from "antd";
import sanitizeHtml from 'sanitize-html';
import { countriesList } from '../../utils/countriesList'
import { sectorsList } from '../../utils/sectorsList'
import { socialSelectList } from '../../utils/socialSelectList'
import { inputs, buttons } from "langs/contactForm";
import { 
	populateGclid,
	populateUtmSource,
	populateUtmMedium,
	populateUtmCampaign,
	populateUtmTerm,
	populateUtmContent,
} from "../../utils/utmHelpers";

const { Option } = Select;

const Contact = ({ classStyle, lang }) => {
	const [form] = Form.useForm();
	const [messageLength, setMessageLength] = useState(0);
	const [comments, setComments] = useState(0);
	const navigate = useNavigate();


	const handleFinish = async (values) => {
		const requestOptions = {
			method: 'POST',
			mode: 'no-cors',
		};
		
		values["00N7R00000H84xH"] = comments;

		const sanitized = {};
		Object.entries(values).forEach(([k, v]) => {
		  if (v != null) {
			sanitized[k] = sanitizeHtml(String(v));
		  }
		});
	  
		const params = new URLSearchParams();
		Object.entries(sanitized).forEach(([k, v]) => {
		  params.append(k, v);
		});
	  
		const queryString = params.toString();
		const url = `https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8&oid=00D7R000005HP0B&${queryString}`;
		
		const response = await fetch(url, requestOptions)
		.then((response) => response)
		.then((result) => console.log(result))
		.catch((error) => console.log('error', error));
		
		console.log("Formulario enviado con éxito:");
		navigate(`/${lang}/thankyou`, { replace: true });
		form.resetFields();
	};

	const handleTextAreaChange = (e) => {
		setMessageLength(e.target.value.length);
		setComments(e.target.value)
	};

	const getFullLanguage = (lang) => {
		let longLanguage = ''
		
		if (lang === 'es') {
			longLanguage = 'Spanish'
		} else if (lang === 'en') {
			longLanguage = 'English'
		} else if (lang === 'pt') {
			longLanguage = 'Portuguese'
		}
		
		return longLanguage
	}
	
	return (
		<Flex className={classStyle} style={{
			background: '#fff'
		}}>
			<Form
				form={form}
				layout="vertical"
				onFinish={handleFinish}
				initialValues={{ remember: false }}
				className="b5-body-500"
			>
				<Form.Item name="00N7R00000H84xL" id="00N7R00000H84xL" initialValue={getFullLanguage(lang)} style={{ display: "none" }}>
					<Input type="hidden" />
				</Form.Item>
				<Form.Item name="company" id="company" initialValue="TBD" style={{ display: "none" }}>
					<Input type="hidden" />
				</Form.Item>
				<Form.Item name="00N7R00000H84xV" id="00N7R00000H84xV" initialValue={populateUtmCampaign()} style={{ display: "none" }}>
					<Input type="hidden" />
				</Form.Item>
				<Form.Item name="00N7R00000H84xW" id="00N7R00000H84xW" initialValue={populateUtmContent()} style={{ display: "none" }}>
					<Input type="hidden" />
				</Form.Item>
				<Form.Item name="00N7R00000H84xX" id="00N7R00000H84xX" initialValue={populateUtmMedium()} style={{ display: "none" }}>
					<Input type="hidden" />
				</Form.Item>
				<Form.Item name="00N7R00000H84xY" id="00N7R00000H84xY" initialValue={populateUtmSource()} style={{ display: "none" }}>
					<Input type="hidden" />
				</Form.Item>
				<Form.Item name="00N7R00000H84xZ" id="00N7R00000H84xZ" initialValue={populateUtmTerm()} style={{ display: "none" }}>
					<Input type="hidden" />
				</Form.Item>
				<Form.Item name="00N7R00000G8jxv" id="00N7R00000G8jxv" initialValue={populateGclid()} style={{ display: "none" }}>
					<Input type="hidden" />
				</Form.Item>
				<Form.Item name="lead_source" id="lead_source" initialValue="MKT-Web Forms" style={{ display: "none" }}>
					<Input type="hidden" />
				</Form.Item>
				<div className="Forms-rows">
					<Form.Item
						label={inputs[lang].fieldName.label}
						name="first_name"
						rules={[{ required: true, message: inputs[lang].fieldName.emptyRule }]}
						style={{ flex: 1 }}
					>
						<Input placeholder="Juan" />
					</Form.Item>
					<Form.Item
						label={inputs[lang].fieldLastname.label}
						name="last_name"
						rules={[{ required: true, message: inputs[lang].fieldLastname.emptyRule }]}
						style={{ flex: 1 }}
					>
						<Input placeholder="Santos" />
					</Form.Item>
				</div>
				<div className="Forms-rows">
					<Form.Item
						label={inputs[lang].fieldEmail.label}
						name="email"
						rules={[
							{ required: true, message: inputs[lang].fieldEmail.emptyRule },
							{ type: "email", message: inputs[lang].fieldEmail.validRule },
							({ getFieldValue }) => ({
								validator(_, value) {
									const personalDomains = [
										"gmail.com",
										"yahoo.com",
										"outlook.com",
										"hotmail.com",
										"aol.com",
										"icloud.com",
									];
					
									const emailDomain = value.split("@")[1];
									if (personalDomains.includes(emailDomain)) {
										return Promise.reject(inputs[lang].fieldEmail.validRule);
									}
					
									return Promise.resolve();
								},
							}),
						]}
						style={{ flex: 1 }}
					>
						<Input placeholder="juan@company.com" />
					</Form.Item>
					<Form.Item
						label={inputs[lang].fieldWebCorporative.label}
						name="url"
						rules={[{ required: true, message: inputs[lang].fieldWebCorporative.emptyRule }]}
						style={{ flex: 1 }}
					>
						<Input placeholder="www.companyurl.com" />
					</Form.Item>
				</div>
				<div className="Forms-rows">
					<Form.Item
						label={inputs[lang].fieldCountry.label}
						name="country_code"
						rules={[{ required: true, message: inputs[lang].fieldCountry.emptyRule }]}
						style={{ flex: 1 }}
					>
						<Select 
							className="form-select"
							placeholder={inputs[lang].fieldCountry.emptyRule}
							options={countriesList}
						/>
					</Form.Item>
					<Form.Item
						label={inputs[lang].fieldSocial.label}
						name="00NaA0000005D6H"
						rules={[{ required: true, message: inputs[lang].fieldSocial.emptyRule }]}
						style={{ flex: 1 }}
					>
						<Select 
							className="form-select"
							placeholder={inputs[lang].fieldSocial.label}
							options={socialSelectList}
						/>
					</Form.Item>
				</div>
				<div className="Forms-rows">
					<Form.Item
						label={inputs[lang].fieldTransactions.label}
						name="00NaA0000005D6I"
						rules={[{ required: true, message: inputs[lang].fieldTransactions.emptyRule }]}
						style={{ flex: 1 }}
					>
						<Select className="form-select" placeholder={inputs[lang].fieldTransactions.emptyRule}>
							<Option value="yes">Yes</Option>
							<Option value="no">No</Option>
						</Select>
					</Form.Item>
					<Form.Item
						label={inputs[lang].fieldIndustry.label}
						name="industry"
						rules={[{ required: true, message: inputs[lang].fieldIndustry.emptyRule }]}
						style={{ flex: 1 }}
					>
						<Select 
							className="form-select"
							placeholder={inputs[lang].fieldIndustry.emptyRule}
							options={sectorsList}
						/>
					</Form.Item>
				</div>
				<div className="Forms-textarea-full">
					<Form.Item
						label={inputs[lang].fieldComments.label}
						name="00N7R00000H84xH"
					>
						<Input.TextArea
							maxLength={400}
							onChange={handleTextAreaChange}
						/>
						<div style={{ textAlign: "right" }}>{messageLength}/400</div>
					</Form.Item>
				</div>
				<Form.Item
					name="heleido"
					valuePropName="checked"
					rules={[{ validator: (_, value) => value ? Promise.resolve() : Promise.reject(new Error(inputs[lang].fieldPrivacy.emptyRule)) }]}
				>
					<Checkbox>{inputs[lang].fieldPrivacy.label}</Checkbox>
				</Form.Item>
				<Form.Item className="Form-Button">
					<Button htmlType="submit" className='button-yellow-md'>
						{buttons[lang].contact}
					</Button>
				</Form.Item>
			</Form>
		</Flex>
	);
};

export default Contact;
